// extracted by mini-css-extract-plugin
module.exports = {"headerTitle":"style_headerTitle__1KJmo","line":"style_line__AyVLD","fontSize1":"style_fontSize1__1046h","bold":"style_bold__lmSJC"};